import script from "./Indicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./Indicator.vue?vue&type=script&lang=ts&setup=true"

import "./Indicator.vue?vue&type=style&index=0&id=11c8372e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c8372e"]])

export default __exports__